



























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
// import { DatePicker } from 'element-ui'
@Component({
  name: 'lb-date-picker',
  // components: {
  //   'el-date-picker': DatePicker
  // }
})

export default class extends Vue {
  @Prop() private value!: string;
  @Prop({ default: '' }) private placeholder!: string;
  @Prop({ type: Boolean, default: false }) private disabled!: boolean;
  @Prop({ type: Boolean, default: false }) private clearable!: boolean;
  @Prop() private size!: string;
  @Prop({ default: 'date' }) private type!: string;
  @Prop({ default: 'yyyy-MM-dd' }) private format!: string;
  @Prop({ default: 'yyyy-MM-dd' }) private valueFormat!: string;
  @Prop() private label!: string;
  @Prop({ type: Boolean, default: false }) private labelFloat!: boolean;
  @Prop({ type: Boolean, default: true }) private icon!: boolean;
  @Prop() private pickerOptions!: object;

  private localValue = this.value;
  private inputFocus = false;

  get isLabelFloat() {
    return this.labelFloat && (this.inputFocus || this.localValue);
  }

  private handleChange(date: any) {
    this.$emit('change', date);
  }

  private handleFocus() {
    this.$emit('focus');
    this.inputFocus = true;
  }

  private handleBlur() {
    this.$emit('blur');
    this.inputFocus = false;
  }

  @Watch('value')
  private onValueChange(val: any) {
    this.localValue = val;
  }

  @Watch('localValue')
  private onLocalValueChange(val: any) {
    this.$emit('input', val);
  }
}
